import get from 'lodash/get';
import {
  FETCH_FABRICATION_JOBS,
  FETCH_FABRICATION_JOBS_SUCCESS,
  FETCH_FABRICATION_JOBS_FAILURE,
  CREATE_FABRICATION_JOB,
  CREATE_FABRICATION_JOB_SUCCESS,
  CREATE_FABRICATION_JOB_FAILURE,
  UPDATE_FABRICATION_JOB,
  UPDATE_FABRICATION_JOB_SUCCESS,
  UPDATE_FABRICATION_JOB_FAILURE,
  DELETE_FABRICATION_JOB,
  DELETE_FABRICATION_JOB_SUCCESS,
  DELETE_FABRICATION_JOB_FAILURE,
} from './types';

const initialState = {
  jobsList: [],
  isJobsListLoading: false,
  isMutationLoading: false,
};

const normalizeJobsResponse = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.rows)) return data.rows;
  if (Array.isArray(data?.records)) return data.records;
  return [];
};

const fabricationJobsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FABRICATION_JOBS:
      return { ...state, isJobsListLoading: true };

    case FETCH_FABRICATION_JOBS_SUCCESS: {
      const resData = get(action, 'response', []);
      return {
        ...state,
        jobsList: normalizeJobsResponse(resData),
        isJobsListLoading: false,
      };
    }

    case FETCH_FABRICATION_JOBS_FAILURE:
      return { ...state, isJobsListLoading: false };

    case CREATE_FABRICATION_JOB:
    case UPDATE_FABRICATION_JOB:
    case DELETE_FABRICATION_JOB:
      return { ...state, isMutationLoading: true };

    case CREATE_FABRICATION_JOB_SUCCESS:
    case CREATE_FABRICATION_JOB_FAILURE:
    case UPDATE_FABRICATION_JOB_SUCCESS:
    case UPDATE_FABRICATION_JOB_FAILURE:
    case DELETE_FABRICATION_JOB_SUCCESS:
    case DELETE_FABRICATION_JOB_FAILURE:
      return { ...state, isMutationLoading: false };

    default:
      return state;
  }
};

export default fabricationJobsReducer;
